import { render, staticRenderFns } from "./AtomLoadingPrimary.vue?vue&type=template&id=16295009"
import script from "./AtomLoadingPrimary.vue?vue&type=script&lang=js"
export * from "./AtomLoadingPrimary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports